import { StyledProps } from '@front10';
import React from 'react';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';
import { TextProps } from '../../../elements/Text/Text';
import Title from './Title';

interface Props {
  showTitle?: boolean;
  showTicketType?: boolean;
  ticketSaleNotes?: string[] | string;
  titleStyles?: React.ComponentPropsWithoutRef<typeof Title>;
  ticketTypeStyles?: TextProps;
}

function TicketType({
  showTitle = true,
  showTicketType = true,
  ticketSaleNotes = [],
  titleStyles,
  ticketTypeStyles,
  ...props
}: StyledProps<Props>) {
  let notesToDisplay: string[] = [];
  if (Array.isArray(ticketSaleNotes)) {
    notesToDisplay = ticketSaleNotes;
  } else if (typeof ticketSaleNotes === 'string') {
    notesToDisplay = [ticketSaleNotes];
  }
  return (
    <Box
      className="station-item-ticket-type"
      display="flex"
      flexDirection="column"
      borderTop={true}
      paddingTop="2"
      paddingBottom="2"
      {...props}
    >
      {showTitle && (
        <Title
          marginBottom="1"
          leftIcon="info-circle"
          labelKey="cmp-bus-directory-map-ticket-type"
          {...titleStyles}
        />
      )}
      {showTicketType &&
        notesToDisplay.map((item) => (
          <Text key={item} {...ticketTypeStyles}>
            {item}
          </Text>
        ))}
    </Box>
  );
}

TicketType.componentName = 'TicketType';

export default TicketType;
